<script>
    /* Stores */
	import { alt } from '../store.js';

	/* Components */  
	import Vitrine		from '../components/Vitrine.svelte'
	import Busca		from './../components/Busca.svelte';
	import ListaImoveis	from './../components/ListaImoveis.svelte'
	import PageHeader	from '../components/PageHeader.svelte'

	let filters = {nt:atria.sell,tipo_negociacao:atria.sell,vistasoftrest_custom:'Promocao,Inverno',force:'1'};
	let numberOfItems = 0;
	let titlePage = 'Promoção de Inverno | ' + $alt;
	let pageHeader = getPageTitle();
	let order = '0';

	let vitrines = [
		{
			image: 'vitrineInverno2.jpg', 
			imageMobile: 'vitrineInvernoM.jpg', 
			title: 'Promoção de Inverno',
			href: '/promocao/inverno'
		}
	];

	function search() {
		filters = {...filters, ...{currentPage:1, ordem:order}};

		pageHeader = getPageTitle();
	}
	function orderChange() {
		search({detail:filters});
	}
	function getPageTitle() {
		let title = 'Promoção de Inverno';

		if (numberOfItems > 0) {
			title += ` <span class="badge background-secondary color-white">${numberOfItems}</span>`;
		}

		return title;
	}
	function afterLoadRealties(json) {
		numberOfItems = json.NumberOfItems;

		pageHeader = getPageTitle();
	}

	search();
</script>

<svelte:head>
    <title>{titlePage}</title>
</svelte:head>

<Vitrine vitrines={vitrines} showDots={true} vitrineHeight="500px"/>

<PageHeader title={pageHeader} setPageTitle={false} classe="background-white mb-0" buttons={[]}>
	<div class="item">
		<div class="buttons">
			<select data-dropup-auto="false" class="selectpicker" bind:value={order} on:change={orderChange}>
				<option data-content="<i class='color-accent far fa-fw fa-sort-amount-down'></i> Menor Preço" value="0">Menor Preço</option>
				<option data-content="<i class='color-accent far fa-fw fa-sort-amount-up'></i> Maior Preço" value="1">Maior Preço</option>					
				<option data-content="<i class='color-accent far fa-fw fa-sort-numeric-down'></i> Menos Dormitórios" value="4">Menos Dormitórios</option>
				<option data-content="<i class='color-accent far fa-fw fa-sort-numeric-up'></i> Mais Dormitórios" value="5">Mais Dormitórios</option>
				<option data-content="<i class='color-accent far fa-fw fa-sort-alpha-down'></i> Bairros A-Z" value="6">Bairros A-Z</option>
				<option data-content="<i class='color-accent far fa-fw fa-sort-alpha-up'></i> Bairros Z-A" value="7">Bairros Z-A</option>
		</select>
		</div>
	</div>
</PageHeader>

<div class="container">	
	<section class="section lista-imoveis pt-0">
		<ListaImoveis showPaginator={false} showNextPrev={true} pageSize={33} holderClass="grid grid-size--3 grid-size-md--3 grid-size-sm--2 grid-size-xs--1" colClass="item" filters={filters} afterLoadRealties={afterLoadRealties} />
	</section>
</div>